<div>
	<div *ngFor="let op of selectedFilterOptions; let idx = index;" class="filter-item">
		<div>{{op.value}}</div>
		<i class="glyphicons glyphicons-remove" (click)="removeFilter(idx)"></i>
	</div>
</div>